module.exports = __webpack_public_path__ + "img/loupe-bgi.01785da.svg";